<template>
  <a-modal v-model="visible" :title="form.payment_id ? '修改收款' : '添加收款'" @ok="handleOk" @cancel="handleClose"
    :confirmLoading="confirmLoading" :maskClosable="false">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="收款类型" prop="payment_type">
        <a-input v-model="form.payment_type" placeholder="请输入费用类型（如退款、 预付款、定金、尾款）"></a-input>
      </a-form-model-item>
      <a-form-model-item label="金额" prop="payment_total">
        <a-input-number v-model="form.payment_total" :step="0.01" style="width: 100%" placeholder="请输入收款金额" />
      </a-form-model-item>
      <a-form-model-item label="收款备注" prop="payment_remark">
        <a-input v-model="form.payment_remark" placeholder="请输入收款备注"></a-input>
      </a-form-model-item>
      <a-form-model-item label="收款时间" prop="payment_receivetime">
        <a-date-picker show-time style="width: 100%" :format="'YYYY/MM/DD HH:mm:ss'"
          :valueFormat="'YYYY/MM/DD HH:mm:ss'" v-model="form.payment_receivetime" :disabled-date="disabledDate" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        trip_id: "",
        payment_id: "",
        payment_type: "",
        payment_total: "",
        payment_remark: "",
        payment_receivetime: "",
      },
      submitLoading: false,
      rules: {
        payment_type: {
          required: true,
          message: "请输入收款类型",
          trigger: "change",
        },
        payment_total: {
          required: true,
          message: "请输入收款金额",
          trigger: "change",
        },
        payment_remark: {
          required: true,
          message: "请输入收款备注",
          trigger: "change",
        },
        payment_receivetime: {
          required: true,
          message: "请选择收款时间",
          trigger: "change",
        },
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 15 },
    };
  },
  methods: {
    init(payment_id, trip_id) {
      this.form.payment_id = payment_id;
      this.form.trip_id = trip_id;
      if (payment_id) {
        this.$http({
          url: '/admin/tripprojectpayment/info',
          method: 'post',
          data: {
            id: payment_id
          }
        }).then(res => {
          this.form = res.data
        })
      }
      this.visible = true;
    },
    disabledDate(current) {
      // 禁用今天之后的日期
      return current && current > new Date();
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.payment_id
              ? "/admin/tripprojectpayment/update"
              : "/admin/tripprojectpayment/create",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success(
                this.form.payment_id ? "修改收款成功" : "添加收款成功"
              );
              this.handleClose();
              this.$emit("ok");
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.visible = false;
    },
  },
};
</script>

<style></style>